import { CabinetVendor, DefaultService} from "@psnb/psnb-api";
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CabinetVendorService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllCabinetVendors();
    }

    getAllCabinetVendors() {
        return this.powerSupplyService.getCabinetVendors().pipe(map(result => result));
    }

    createCabinetVendor(model: CabinetVendor) {
        return this.powerSupplyService.createCabinetVendor(model).pipe(map(result => result));
    }

    updateCabinetVendor(model: CabinetVendor) {
        return this.powerSupplyService.updateCabinetVendor(model).pipe(map(result => result));
    }

    deleteCabinetVendor(id: number) {
        return this.powerSupplyService.deleteCabinetVendor(id).pipe(map(result => result));
    }
}
